import { render, staticRenderFns } from "./ForcedRegistrationDetails.vue?vue&type=template&id=442eda50&scoped=true&"
import script from "./ForcedRegistrationDetails.vue?vue&type=script&lang=js&"
export * from "./ForcedRegistrationDetails.vue?vue&type=script&lang=js&"
import style0 from "./ForcedRegistrationDetails.vue?vue&type=style&index=0&id=442eda50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "442eda50",
  null
  
)

export default component.exports